import React from "react";
import { ArrowUpRight } from "lucide-react";
import { blogPosts } from "../mock";

export default function Blog() {
  return (
    <section id="insights" className="py-24 lg:py-32 bg-[#eee3cf]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428] mb-4">
              Insights & Standards
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527]">
              Tidy Tips & Field Notes
            </h2>
          </div>
          <a
            href="#"
            className="inline-flex items-center gap-2 text-[#143527] font-medium hover:text-[#e8a428] transition-colors"
          >
            View all articles <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.title}
              className="group bg-[#f4ebde] rounded-3xl overflow-hidden flex flex-col transition-transform hover:-translate-y-1 duration-300"
            >
              <div className="aspect-[5/3] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <span className="text-xs uppercase tracking-[0.2em] text-[#e8a428] font-semibold mb-3">
                  {post.category}
                </span>
                <h3 className="font-serif text-2xl text-[#143527] leading-tight mb-3">
                  {post.title}
                </h3>
                <p className="text-[14px] text-[#143527]/70 leading-relaxed mb-5 flex-1">
                  {post.excerpt}
                </p>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 text-[#143527] font-medium text-sm uppercase tracking-wider hover:text-[#e8a428] transition-colors"
                >
                  Read more <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
